// campaignViewTypes.ts

import { ReactNode } from "react";

export interface CampaignMetrics {
    totalSent: number;
    totalDelivered: number;
    totalRead: number;
    totalReplied: number;
    totalFailed: number;
    totalDeliveredRate: number;
    totalReadRate: number;
    // New metrics structure from API
    completed?: number;
    failed?: number;
    sending?: number;
    sent?: number;
    read?: number;
    replied?: number;
    received?: number;
    delivered?: number;
    opened?: number;
    clicked?: number;
  }
  
  export type ServiceType = 'whatsapp' | 'gmail' | 'brevo';

  export interface LeadActivity {
    type: string;
    timestamp: string;
    details?: string;
  }
  
// In campaignViewTypes.ts
export interface Lead {
  _id: string;
  key: string;
  name: string;
  status: StatusType[];
  lastActivity: string;
  lastActivityType: string;
  lastActivityLabel: string; // New field
  phone?: string;
  email?: string;
}
  
export interface LeadData {
    _id: string;
    name: string;
    status: StatusType[];
    lastActivity: string;        // Changed from LeadActivity type to simple string
    lastActivityType: string;    // Added to match actual data
    phone?: string;             // Changed from phoneNumber to phone
    email?: string;
}

  
  export interface LastActivityDetails {
    type: string;
    timestamp: string;
    details?: string;
  }

  export interface CampaignMetrics {
    totalSent: number;
    totalDelivered: number;
    totalRead: number;
    totalReplied: number;
    totalFailed: number;
    totalDeliveredRate: number;
    totalReadRate: number;
    totalRepliedRate: number;
  }
  
  export interface ErrorData {
    details?: string;
  }
  
  export interface ErrorObject {
    code?: number;
    title?: string;
    message?: string;
    error_data?: ErrorData;
  }
  
  interface MessageContent {
    title?: string;
    message?: string;
    subject?: string;
    tags?: string[];
  }
  
  interface DetailsContent {
    details: string;
    type?: string;
    files?: any[];
  }

  export interface CampaignError {
    error?: ErrorObject | ErrorObject[] | string | null;
  }
  
  export interface ContentDetails {
    title: string;
    tags: string[];
    subject: string;
    message: string;
  }
  
   export interface ContentStructure {
    _id: string;
    type: string;
    details: ContentDetails;
    // We don't need to type other fields as we won't use them
  }


  export interface CampaignFormData extends CampaignError {
    totalClicked: number;
    totalRepliedRate: ReactNode;
    // Email-specific metrics
    totalQueued?: number;
    totalProcessed?: number;
    totalMailSent?: number;
    totalOpened?: number;
    openRate?: number;
    clickRate?: number;
  
    dailySentCount?: number;
    content?: {
      title?: string;
      tags?: string[];
      subject?: string;
      message?: string;
      details?: string;
    } | string;
     serviceType?: string;
     whatsappTemplate?: {
      name: string;
      [key: string]: any;
    };
    totalDeliveredRate: ReactNode;
    
    totalReadRate: ReactNode;
    _id: string;
    name: string;
    templateName?: string;
    createdBy: {
      firstName: string;
      lastName?: string;
    };
    createdAt: string;
    status: string;
    totalSent: number;
    totalRead: number;
    totalReplied: number;
    totalFailed: number;
    totalLeads: number;
    totalDelivered: string;
    scheduleAt: "date",
    isPaused: boolean,
    isCancelled: string,
    dailyLimit: string,
    leads?: Lead[];
    metrics: CampaignMetrics;
    pagination?: PaginationMetadata;
    error?: null | string | Array<{
      code?: number;
      title?: string;
      message?: string;
      error_data?: {
        details?: string;
      };
    }>;
  }

  export interface CampaignViewProps {
    campaignId: string;
    onClose: () => void;
  }

  export const STATUS_COLORS = {
    scheduled: "#F7CB73",
    started: "#3FAEFD",
    started_sending: "#3FAEFD", 
    in_progress: "#3FAEFD",
    partially_completed: "#F7CB73",
    completed: "#4CB050",
    failed: "#FF4747",
    paused: "#F7CB73",
    cancelled: "#E32C2C",
    pending: "#F7CB73"
  } as const;
  
  export type StatusType = 'scheduled' | 'started' | 'started_sending' | 'in_progress' |
  'partially_completed' | 'completed' | 'failed' | 'paused' | 'cancelled' | 'pending';

  export type LeadStatusType = 'sent' | 'read' | 'replied' | 'failed' | 'delivered' | 'completed' | 'opened' | 'clicked';

  export interface LeadActivity {
    type: string;
    timestamp: string;
    details?: string;
  }
  
  export interface CampaignQueryParams {
    page?: number;
    perPage?: number;
    status?: StatusType;
    search?: string;
    orderBy?: string;
    isAscending?: boolean;
    buttonAction?: string;
  }
  export interface PaginationMetadata {
    total: number;
    page: number;
    perPage: number;
    totalPages: number;
  }